// @flow
import React from 'react';
import Modal from 'react-modal';

import BoxHeader from 'components/BoxHeader';
import Button from 'components/ButtonDeprecated';
import Heading from 'components/Heading';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import UrgentMessagingLearnMoreDialog from './UrgentMessagingLearnMoreDialog';

import type { MessageType } from './SplitComposer';

import AnnouncementImage from 'assets/images/SplitComposer/announcement.svg';
import UrgentAnnouncementImage from 'assets/images/SplitComposer/urgent.svg';

type Props = {
  messageType: MessageType,
};

type State = {
  urgentMessagingLearnMoreDialogOpen: boolean,
};

const mapImageToType = {
  urgent: UrgentAnnouncementImage,
  message: AnnouncementImage,
};
const mapTextToType = {
  urgent: 'Urgent Message',
  message: 'Message',
};
const mapColorToType = {
  urgent: 'apple',
  message: 'mascot',
};

export default class SplitComposerHeader extends React.Component<Props, State> {
  state = {
    urgentMessagingLearnMoreDialogOpen: false,
  };

  openUrgentMessagingLearnMoreDialog = () => {
    this.setState({ urgentMessagingLearnMoreDialogOpen: true });
  };

  closeUrgentMessagingLearnMoreDialog = () => {
    this.setState({ urgentMessagingLearnMoreDialogOpen: false });
  };

  getActionForType(messageType: MessageType) {
    if (messageType === 'urgent') {
      return (
        <Button
          onClick={this.openUrgentMessagingLearnMoreDialog}
          size="xxxsmall"
          color="mascot"
          level="text">
          <Text weight="semibold" size="medium">
            Learn more
          </Text>
        </Button>
      );
    }
    return null;
  }

  render() {
    const { messageType } = this.props;
    return (
      <React.Fragment>
        {messageType === 'urgent' && (
          <Modal isOpen={this.state.urgentMessagingLearnMoreDialogOpen}>
            <UrgentMessagingLearnMoreDialog
              onRequestHide={this.closeUrgentMessagingLearnMoreDialog}
            />
          </Modal>
        )}
        <BoxHeader
          title={
            <MediaObject center figure="right">
              <MediaObject gutter="small">
                <Image src={mapImageToType[messageType]} />
                <Heading flush>
                  <Text color={mapColorToType[messageType]} weight="semibold">
                    {mapTextToType[messageType]}
                  </Text>
                </Heading>
              </MediaObject>
              {this.getActionForType(messageType)}
            </MediaObject>
          }
          textAlign="left"
          flush
        />
      </React.Fragment>
    );
  }
}
